import TkDownloadLink from "../../../components/atoms/TkDownloadLink";
import {
  CorpTypeList2,
  FacilityKbn,
  FacilityKind,
  formClassCorp,
  formClassFacility,
  FormKbn,
  Prefectures,
} from "../../../assets/data/Constants";
import { TkGetCode } from "../../../utils/TkGetCode";
import { Typography } from "@mui/material";
import { IAPI_CON027_Response } from "../../../type/apiType/IAPI_CON027";
import { changeAmountFormat } from "../../../utils/useTools";

function funCorporateInfoBodyList(res: IAPI_CON027_Response) {
  let fileClass1: any, fileClass2: any, fileClass3: any;
  if (res.fileList) {
    res.fileList.forEach((file: any) => {
      if (file.formKbn !== FormKbn["法人書類"]) return;

      switch (file.formClass) {
        case formClassCorp["履歴事項全部証明書（写）"]:
          fileClass1 = file;
          break;
        case formClassCorp["就業規則"]:
          fileClass2 = file;
          break;
        case formClassCorp["給与規程"]:
          fileClass3 = file;
          break;
        default:
          break;
      }
    });
  }

  const formatZipcode = (zipcode: string | undefined): string => {
    if (zipcode?.length !== 7) {
      return zipcode ?? "";
    }
    return `${zipcode.slice(0, 3)}-${zipcode.slice(3)}`;
  };

  const bodyList = [
    [
      {
        children: TkGetCode(CorpTypeList2, res.businessOwnerClass),
      },
      {
        children:
          (res.corpNumber ? res.corpNumber + ":" : "") + (res.corpName ?? ""),
      },
      {
        children: res.directorTitle,
      },
      {
        children: res.directorName,
      },
      {
        children: (
          <>
            <Typography style={{ fontSize: "14px" }}>
              〒{formatZipcode(res.zipcode)}
            </Typography>
            {TkGetCode(Prefectures, res.prefectureCd)}
            {res.addressCity}
            {res.addressOthers}
          </>
        ),
      },
      {
        children: (
          <>
            <Typography style={{ fontSize: "14px" }}>
              代表電話番号：{res.tel}
            </Typography>
            <Typography style={{ fontSize: "14px" }}>
              代表FAX番号: {res.fax}
            </Typography>
          </>
        ),
      },
      {
        children: fileClass1 ? (
          <TkDownloadLink
            base64filedata={fileClass1.fileBase64}
            dataname={fileClass1.formName}
            downloadBase64={true}
          />
        ) : (
          <></>
        ),
      },
      {
        children: fileClass2 ? (
          <TkDownloadLink
            base64filedata={fileClass2.fileBase64}
            dataname={fileClass2.formName}
            downloadBase64={true}
          />
        ) : (
          <></>
        ),
      },
      {
        children: fileClass3 ? (
          <TkDownloadLink
            base64filedata={fileClass3.fileBase64}
            dataname={fileClass3.formName}
            downloadBase64={true}
          />
        ) : (
          <></>
        ),
      },
    ],
  ];

  return bodyList;
}

function funFacilityInfoBodyList(res: IAPI_CON027_Response) {
  const list = res.facilityList;

  let bodyList = list?.map((item) => {
    let documentaryEvidence = res.fileList?.find(
      (file) =>
        file.formKbn === FormKbn["施設書類"] &&
        file.formClass ===
          formClassFacility["当該施設・事業を経営している証拠書類"] &&
        file.facilityNo === item.facilityNo
    );
    return [
      {
        children: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
      },
      {
        children: FacilityKind[item.facilityKind as keyof typeof FacilityKind],
      },
      {
        children: TkGetCode(FacilityKbn, item.facilityKbn),
      },
      {
        children: changeAmountFormat(item.admissionCapacityNum ?? 0),
        align: "right",
      },
      {
        children: changeAmountFormat(item.staffBaseNum ?? 0),
        align: "right",
      },
      {
        children: changeAmountFormat(item.totalStaffNum ?? 0),
        align: "right",
      },
      {
        children: changeAmountFormat(item.joinStaffNum ?? 0),
        align: "right",
      },
      {
        children: changeAmountFormat(item.yearJoindisableStaffNum ?? 0),
        align: "right",
      },
      {
        children: changeAmountFormat(item.timeJoindisableStaffNum ?? 0),
        align: "right",
      },
      {
        children: documentaryEvidence ? (
          <TkDownloadLink
            dataname={documentaryEvidence.formName ?? ""}
            base64filedata={documentaryEvidence.fileBase64 ?? ""}
            downloadBase64
          />
        ) : null,
      },
    ];
  });

  return bodyList;
}

export { funFacilityInfoBodyList, funCorporateInfoBodyList };
